module.exports = __webpack_public_path__ + "Roboto-Regular.2751ee43015f9884c364.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/font/roboto/Roboto-Regular.woff2
// module id = ../../../../../src/font/roboto/Roboto-Regular.woff2
// module chunks = 1